import { FetchBaseQueryError, createApi } from '@reduxjs/toolkit/query/react'

import { AppLanguage } from '~/types/locale'
import { QuestMetadata } from '~/types/quest'
import { getSanityLanguage, SANITY } from '~/services/sanity.service'
import { apiPrivate } from '~/redux/utils/hom-api'

export const questApi = createApi({
  reducerPath: 'questApi',
  baseQuery: apiPrivate,
  tagTypes: ['Quest'],
  endpoints: (builder) => ({
    getQuestMetadata: builder.query<QuestMetadata[], { language: AppLanguage }>({
      queryFn: async ({ language }) => {
        try {
          return { data: await SANITY.getQuestMetadata({ language: getSanityLanguage(language) }) }
        } catch (error) {
          return { error: error as FetchBaseQueryError }
        }
      },
    }),
  }),
})

export const { useGetQuestMetadataQuery } = questApi
